import React from 'react';
import {
  Place,
  PhoneAndroid,
  Email,
} from '@material-ui/icons';
import styles from './contact.module.css';

const Contacts = () => {
  return (
    <div className={styles.Main}>
      <h1>Contacts</h1>
      <div className={styles.Card}>
        <div>
          <Place
            style={{ fontSize: 36 }}
            className={styles.Icon}
          />{' '}
          Kigali - Rwanda
        </div>
        <div>
          <PhoneAndroid
            style={{ fontSize: 36 }}
            className={styles.Icon}
          />{' '}
          +250 789 121 324 / +250 726 105 144
        </div>
        <div>
          <Email
            style={{ fontSize: 36 }}
            className={styles.Icon}
          />
          habinezajanvier688@gmail.com
        </div>
      </div>
    </div>
  );
};

export default Contacts;
